const mailTracker = async (className) => {
  const mailTracker = document.createElement("button");
  mailTracker.className = className || "mail-tracker";
  document.body.appendChild(mailTracker);
  mailTracker.click();
  document.body.removeChild(mailTracker);
};

export default mailTracker;